import React, { useState } from 'react';
import PropTypes from 'prop-types';

function Key({ isDefaultCamelot = true, simple, camelot }) {
  const [isCamelot, setSwitch] = useState(isDefaultCamelot);
  const onClick = () => setSwitch(!isCamelot);
  return (
    <span className={`link-enable switch-key`} onClick={onClick}>{ isCamelot ? camelot : simple}</span>
  )
}

Key.propTypes = {
  simple: PropTypes.string,
  camelot: PropTypes.string,
  isDefaultCamelot: PropTypes.bool,
}

export default Key;
